import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { Card, CardHeader, CardMedia, Typography } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import { inject, observer } from 'mobx-react';
import Divider from '@material-ui/core/Divider';
import { createComponent as cc } from 'react-fela';
import {
  ThumbUp,
  ThumbDown,
  ThumbsUpDown,
  ArrowForward,
} from '@material-ui/icons';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import GridWrapper from '../../../components/wrappers/GridWrapper';
import GridWrapper100 from '../../../components/wrappers/GridWrapper100';
import FeedbackList from '../feedbackList/FeedbackList';
import UserFeedbackChart from '../../../components/userDetail/UserFeedbackChart';

const FedbackBloclWrapper = cc(() => ({
  marginTop: '20px',
}));

const CardMediaWrapper = cc(
  () => ({
    height: '100%',
    minHeight: '350px',
  }),
  CardMedia,
  ['image'],
);

const TypographyWithmargin = cc(
  () => ({
    marginBottom: '20px',
  }),
  Typography,
  ['variant'],
);

const CustomBadge = cc(
  () => ({
    marginTop: '10px',
    marginRight: '-5px',
  }),
  Badge,
  ['badgeContent'],
);

@inject('store')
@observer
class UserDetail extends Component {
  constructor(props) {
    super(props);
    this.userId = props.match.params.userId;
    this.feedBotStore = props.store.feedBotStore;
    this.dashBoardStore = props.store.dashBoardStore;
    this.state = { selectedTab: 0 };
  }

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  renderFeedbackSegment = (feedbact, segmentTitle) => (
    <FedbackBloclWrapper>
      <TypographyWithmargin variant="display2">{`${segmentTitle}`}</TypographyWithmargin>
      <GridWrapper100 container>
        <FeedbackList feedbackList={feedbact} />
      </GridWrapper100>
    </FedbackBloclWrapper>
  );

  renderUserHeroCard = usrData => (
    <Card>
      <CardHeader title={usrData.userName} subheader={usrData.email} />
      <Divider light />
      <Grid container direction="row" justify="space-around">
        <Grid item xs={12} md={6}>
          <CardMediaWrapper image={usrData.heroImgUrl} />
        </Grid>
        <Grid item xs={12} md={6}>
          <UserFeedbackChart
            positive={usrData.thumbsUp}
            negative={usrData.thumbsDown}
            neutral={usrData.numberOfNeutralFeedback}
          />
        </Grid>
        <Grid item xs={12}>
          <Tabs
            value={this.state.selectedTab}
            onChange={this.handleTabChange}
            fullWidth
            centered
          >
            <Tab
              label="Positive feedback"
              icon={
                <CustomBadge badgeContent={usrData.thumbsUp}>
                  <ThumbUp color="primary" />
                </CustomBadge>
              }
              disabled={!usrData.thumbsUp}
            />
            <Tab
              label="Negative feedback"
              icon={
                <CustomBadge badgeContent={usrData.thumbsDown}>
                  {' '}
                  <ThumbDown color="error" />{' '}
                </CustomBadge>
              }
              disabled={!usrData.thumbsDown}
            />
            <Tab
              label="Neutral feedback"
              icon={
                <CustomBadge badgeContent={usrData.numberOfNeutralFeedback}>
                  <ThumbsUpDown color="disabled" />
                </CustomBadge>
              }
              disabled={!usrData.numberOfNeutralFeedback}
            />
            <Tab
              label="Submitted feedback"
              icon={
                <CustomBadge badgeContent={usrData.numberOfSubmittedFeedback}>
                  <ArrowForward />
                </CustomBadge>
              }
              disabled={!usrData.numberOfSubmittedFeedback}
            />
          </Tabs>
        </Grid>
      </Grid>
    </Card>
  );

  render() {
    const filterString = this.dashBoardStore.searchString;
    const userData = this.feedBotStore.userData(this.userId, filterString);
    const neutralFeedback = this.feedBotStore.neutralFeedbackOfUser(
      this.userId,
      filterString,
    );
    const positiveFeedback = this.feedBotStore.positiveFeedbackOfUser(
      this.userId,
      filterString,
    );
    const negativeFeedback = this.feedBotStore.negativeFeedbackOfUser(
      this.userId,
      filterString,
    );
    const submittedFeedback = this.feedBotStore.usersSubmittedFeedback(
      this.userId,
      filterString,
    );

    const { selectedTab } = this.state;

    return (
      <React.Fragment>
        <GridWrapper>
          <Grid container>
            <Grid item xs={12}>
              {this.renderUserHeroCard(userData)}
            </Grid>
            <Grid item xs={12}>
              {selectedTab === 0 &&
                this.renderFeedbackSegment(
                  positiveFeedback,
                  'Positive feedback',
                )}
            </Grid>

            <Grid item xs={12}>
              {selectedTab === 1 &&
                this.renderFeedbackSegment(
                  negativeFeedback,
                  'Negative feedback',
                )}
            </Grid>
            <Grid item xs={12}>
              {selectedTab === 2 &&
                this.renderFeedbackSegment(neutralFeedback, 'Neutral feedback')}
            </Grid>
            <Grid item xs={12}>
              {selectedTab === 3 &&
                this.renderFeedbackSegment(
                  submittedFeedback,
                  'Submitted feedback',
                )}
            </Grid>
          </Grid>
        </GridWrapper>
      </React.Fragment>
    );
  }
}

export default UserDetail;



// WEBPACK FOOTER //
// ./src/routes/home/userDetail/UserDetail.js